<template>
  <div class="rate-deal" v-if="discount_percentage">
    <vb-icon
      class="mr-1"
      :name="'tags'"
      :color="sass('success')"
      :size="14"
    />
    <span>{{ discount_percentage }}% di sconto</span>
  </div>
</template>

<script>
import { multiply, divide, subtract, round } from 'mathjs'
import { markupPricing } from "@src/sites/liveeps/utilities/utilities"

export default {
  name: 'rate-deal',

  inject: ['prices'], // prices è una funzione che restituisce i prezzi del rate

  components: {
  },

  props: {
  },

  data() {
    return {
    }
  },

  computed: {

    discount_percentage() {
      const pricing = markupPricing(this.prices()),
            live_price = pricing.live_price,
            before_price = pricing.strikeThrough || pricing.markedUpTotalBeforeDiscount

      if (!before_price) return false

      const percentage = multiply(
        divide(
          subtract(before_price, live_price),
          before_price
        ),
        100
      )
      return round(percentage)
    },
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .rate-deal {
    display: flex;
    align-items: center;
    font-size: $font-size-md;
    color: $success;
    font-weight: $vb-font-weight-semibold;
    justify-content: center;

    @include media-breakpoint-up(md) {
      justify-content: flex-end;
    }
  }

</style>